import Typography from '@mui/material/Typography';
import React from 'react';

// Split out of WidgetPrimitives so SegmentItem can use these without importing
// WidgetPrimitives, which renders SegmentItem.
export const WIDGET_COLORS = {
  green: '#44A047',
  blue: '#4A90E2',
  lightBlue: '#8FC7F2',
  yellow: '#F5A623',
  black: '#1F1F1F',
  dark: '#252525',
  gray: '#666666',
  lightGray: '#E0E0E0'
};

interface DataTextProps {
  children: React.ReactNode;
  color?: string;
  inline?: boolean;
  lineHeight?: number;
}

export const DataH5 = ({ children, color = '#1F1F1F', inline = true, lineHeight }: DataTextProps) => (
  // @ts-ignore - dash-h5 is a custom variant registered in theme
  <Typography variant="dash-h5" style={{ display: inline ? 'inline' : 'block', color, lineHeight }}>
    {children}
  </Typography>
);

export const DataLabel10 = ({ children }: DataTextProps) => (
  <Typography style={{ fontSize: 10, fontWeight: 400, color: WIDGET_COLORS.gray, display: 'block' }}>
    {children}
  </Typography>
);

export const DataLabel11 = ({ children }: DataTextProps) => (
  <Typography style={{ fontSize: 11, fontWeight: 400, color: WIDGET_COLORS.gray, display: 'inline' }}>
    {children}
  </Typography>
);

export const DataLabel12 = ({ children }: DataTextProps) => (
  <Typography style={{ fontSize: 12, fontWeight: 400, color: WIDGET_COLORS.gray, display: 'inline' }}>
    {children}
  </Typography>
);
